import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheVaultEntrance from "./sections/TheVaultEntrance";
import CareerImpactInNumbers from "./sections/CareerImpactInNumbers";
import PrePlacementTrainingPrograms from "./sections/PrePlacementTrainingPrograms";
import AcademySuccessStories from "./sections/AcademySuccessStories";
import IronAndSweatGallery from "./sections/IronAndSweatGallery";
import ReadyToLevelUp from "./sections/ReadyToLevelUp";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheVaultEntrance />
      <CareerImpactInNumbers />
      <PrePlacementTrainingPrograms />
      <AcademySuccessStories />
      <IronAndSweatGallery />
      <ReadyToLevelUp />
      <Footer />
    </div>;
}